var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.99999 13.8333C0.99999 14.75 1.74999 15.5 2.66666 15.5H9.33332C10.25 15.5 11 14.75 11 13.8333V5.5C11 4.58333 10.25 3.83333 9.33332 3.83333H2.66666C1.74999 3.83333 0.99999 4.58333 0.99999 5.5V13.8333ZM3.49999 5.5H8.49999C8.95832 5.5 9.33332 5.875 9.33332 6.33333V13C9.33332 13.4583 8.95832 13.8333 8.49999 13.8333H3.49999C3.04166 13.8333 2.66666 13.4583 2.66666 13V6.33333C2.66666 5.875 3.04166 5.5 3.49999 5.5ZM8.91666 1.33333L8.32499 0.741667C8.17499 0.591667 7.95832 0.5 7.74166 0.5H4.25832C4.04166 0.5 3.82499 0.591667 3.67499 0.741667L3.08332 1.33333H0.99999C0.541656 1.33333 0.166656 1.70833 0.166656 2.16667C0.166656 2.625 0.541656 3 0.99999 3H11C11.4583 3 11.8333 2.625 11.8333 2.16667C11.8333 1.70833 11.4583 1.33333 11 1.33333H8.91666Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.234484b5e74874d9e30a3a32860aba58.svg";
export { ForwardRef as ReactComponent };